import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SuiLocalizationService } from "./services/localization.service";
var SuiLocalizationModule = /** @class */ (function () {
    function SuiLocalizationModule() {
    }
    SuiLocalizationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    providers: [SuiLocalizationService]
                },] },
    ];
    /** @nocollapse */
    SuiLocalizationModule.ctorParameters = function () { return []; };
    return SuiLocalizationModule;
}());
export { SuiLocalizationModule };
//# sourceMappingURL=localization.module.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/behaviors/localization/localization.module.js
// module id = 1078
// module chunks = 0